import { createAsyncCategoryHandler } from "../category-dispatcher";
import { propertyTools } from "./property-tools";

/**
 * Category handler for `ui_bind` — the declarative binding tool that replaces
 * the older imperative `ui_property.set_*` flow.
 *
 * Operations:
 *   - `get_options` (async): returns the bindables manifest for a set of components,
 *     after lazily loaded picker branches have settled
 *   - `apply`      (async): applies a batch of bindings (value props + event attaches)
 */
export const handleBindCategory = createAsyncCategoryHandler(
  {},
  {
    get_options: propertyTools.async!.ui_bindables_get_settled,
    apply: propertyTools.async!.ui_bind
  }
);
